import Vue from 'vue'
import vueI18n from 'vue-i18n'

import en from './langs/en' // 英语
import zh from './langs/zh' // 中文
import fr from './langs/fr' // 法语
import it from './langs/it' // 意大利语
import es from './langs/es' // 西班牙语
import id from './langs/id' // 印尼语
// const en = require('https://voopoo-test.oss-cn-shenzhen.aliyuncs.com/iccpp-eu/static/lang/en-mobile.json')
// const zh = require('https://voopoo-test.oss-cn-shenzhen.aliyuncs.com/iccpp-eu/static/lang/zh-CN-mobile.json')

Vue.use(vueI18n)
const messages = {
  en,
  zh,
  fr,
  it,
  es,
  id
}
const currentLang = localStorage.getItem('currentLang') || null
// const langContent = localStorage.getItem('langContent') || null
const i18n = new vueI18n({
  locale: currentLang || 'en',
  fallbackLocale: 'en', // 兜底语言
  silentTranslationWarn: true, // 关闭翻译缺失警告
  // messages: (currentLang && langContent) ? { [localStorage.getItem('currentLang')]: JSON.parse(langContent) } : messages
  messages: messages
})

export default i18n
